import { render, staticRenderFns } from "./NavItemTree.vue?vue&type=template&id=0e2119bc&scoped=true&name=nav-item-tree&"
import script from "./NavItemTree.vue?vue&type=script&lang=js&"
export * from "./NavItemTree.vue?vue&type=script&lang=js&"
import style0 from "./NavItemTree.vue?vue&type=style&index=0&id=0e2119bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2119bc",
  null
  
)

export default component.exports